var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cart-header d-none d-lg-block" }, [
    _c("div", { staticClass: "item-row" }, [
      _c("div", { staticClass: "item-product-image" }, [
        _vm._v(_vm._s(_vm.$dictionary("ordering.basket.product_image"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item-description" }, [
        _vm._v(_vm._s(_vm.$dictionary("ordering.basket.item_description"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item-quantity text-center" }, [
        _vm._v(_vm._s(_vm.$dictionary("ordering.basket.quantity"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item-price-unit" }, [
        _vm._v(_vm._s(_vm.$dictionary("ordering.basket.price_unit"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item-price-subtotal" }, [
        _vm._v(_vm._s(_vm.$dictionary("ordering.basket.subtotal"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item-delete" }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }